import React from 'react';
import { Edit, Copy, Eye, FileText } from 'lucide-react';
import useAssessmentManagementStore from '@/stores/AdminStore/AssessmentManagementStore';
import './AssessmentList.css';

const AssessmentList: React.FC = () => {
  const { assessments } = useAssessmentManagementStore();

  return (
    <div className="admin-assessment-list">
      <div className="admin-assessment-cards-grid">
        {assessments?.map((assessment) => (
          <div key={assessment.id} className="admin-assessment-card">
            <div className="admin-assessment-card-header">
              <div className="admin-assessment-icon-wrapper">
                <FileText size={32} />
              </div>
              <span className="admin-assessment-status-badge">
                {assessment.status}
              </span>
            </div>

            <h3 className="admin-assessment-card-title">{assessment.name}</h3>
            <p className="admin-assessment-card-description">{assessment.description}</p>

            <div className="admin-assessment-card-details">
              <div className="admin-assessment-detail-row">
                <span className="admin-assessment-detail-label">Type:</span>
                <span className="admin-assessment-detail-value">{assessment.type}</span>
              </div>
              <div className="admin-assessment-detail-row">
                <span className="admin-assessment-detail-label">Questions:</span>
                <span className="admin-assessment-detail-value">{assessment.questions}</span>
              </div>
              <div className="admin-assessment-detail-row">
                <span className="admin-assessment-detail-label">Time:</span>
                <span className="admin-assessment-detail-value">{assessment.time}</span>
              </div>
              <div className="admin-assessment-detail-row">
                <span className="admin-assessment-detail-label">Passing:</span>
                <span className="admin-assessment-detail-value">{assessment.passing}</span>
              </div>
            </div>

            <div className="admin-assessment-card-actions">
              <button className="admin-assessment-action-btn copy">
                <Copy size={18} />
              </button>
              <button className="admin-assessment-action-btn view">
                <Eye size={18} />
                View
              </button>
              <button className="admin-assessment-action-btn edit">
                <Edit size={18} />
                Edit
              </button>
            </div>

            <div className="admin-assessment-card-footer">
              Created {assessment.created}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssessmentList;
